import axios from 'axios'
import { ref } from 'vue'
import Mango from './mango'
import { clearClientSession } from './authSession'
import { apiDomain, port, useDevAPI } from '../../../config/config/settings.json'
const isDev = import.meta.env.DEV

let billing = `
billing {
    paymentId,
    firstName,
    lastName,
    phoneNumber,
    payment {
        creditCard {
            cardNumber,
            cardType,
            expirationDate,
        },
        bankAccount {
            accountNumber,
            accountType,
            echeckType,
            nameOnAccount,
            routingNumber
        }
    }
}
`

let regFields = Mango.collections
	.find((c) => c.name == 'registrations')
	.fields.filter((f) => !['price', 'attendees', 'rate', 'billing', 'author', 'coupon', 'referringChurch', 'referringMember', 'relatedEvents', 'lineItems', 'bundlesApplied'].includes(f.name))
	.map((f) => f.name)
	.join(', ')
regFields = `
    ${regFields},
    ${billing},
    id
    updated
    rate {
        id,
        rateType,
        kind,
        price
        ageRates {
            label,
            maxAge,
            price
            altPrice
        }
        event {
            id
            title
            shortName
            genderWaitlistEnabled
            requiresGender
            ageMin
            ageMax
            hasChoirOption
            arkPassEligible
            useNewCheckout
            status
            startDate
            endDate
            fullRefundMonths
            halfRefundMonths
            transferEmail
            studentRate {
                id
                title
                price
            }
            bannerImage {
                url
            }
            titleImage {
                url
            }
            address {
                address
                venue
                human
                city
                state
                zip
                country
            }
            relatedEvents {
                id
                title
                status
                startDate
                endDate
                bannerImage {
                    url
                }
                titleImage {
                    url
                }
                shortName
                genderWaitlistEnabled
            }
        }
    }
    relatedEvents {
        event {
            id
            title
            shortName
            startDate
            endDate
            descriptionMin
            bannerImage { url }
            titleImage { url }
            includedWith { id title shortName }
            requiresGender
            genderWaitlistEnabled
            ageMin
            ageMax
            address {
                venue
                city
                state
            }
        }
        rate {
            id
            rateType
            price
            ageRates {
                label,
                maxAge,
                price
                altPrice
            }
        }
        total
        attendees {
            firstName,
            lastName,
            church,
            age
        }
    }
    coupon {
        code
    }
    lineItems {
        kind,
        label,
        amount,
        eventRateId,
        bundleId,
        couponId,
        quantity,
        unitAmount
    }
    price {
        total,
        subtotal,
        discount
    }
    attendees {
        attendingChoir,
        firstName,
        lastName,
        church,
        age,
        student
    }
`

const getUser = async (user, { verify = false } = {}) => {
	user = user || { value: { loading: true } }

	let userId = window.localStorage.getItem('user')
	let Authorization = window.localStorage.getItem('auth')

	// No live token — drop every leftover identity, not just `user`.
	if (!Authorization || Authorization === 'null') {
		clearClientSession()
		user.value = {}
		return {}
	}

	if (Authorization) window.localStorage.setItem('token', Authorization)

	// Cached window.user is not a proof of a live token. Register / verify
	// must hit userLite so a wiped `auth` cannot ride on stale memory.
	if (!verify && window.user?.member?.id) {
		console.log('got it!')
		user.value = window.user
		window.user = null
		return user.value
	}

	if (!userId && !verify) return {}

	let api = useDevAPI ? `http://localhost:${port}` : `${apiDomain}`
	if (!isDev) api = `${apiDomain}`

	try {
		const r = await axios.get(`${api}/controllers/userLite`, { headers: { Authorization } })
		if (!r.data?.member?.id) {
			clearClientSession()
			user.value = {}
			return {}
		}
		user.value = { ...r.data, loading: false }
		return user.value
	} catch (e) {
		if (e?.response?.status === 401 || verify) clearClientSession()
		user.value = {}
		return {}
	}
}

// Hit userLite and, if the session is dead, wipe localStorage + cookie +
// axios header. Caller must assign store.user (the Vue member) itself.
const verifySession = async () => {
	const fresh = await getUser(null, { verify: true })
	if (fresh?.member?.id) return fresh
	clearClientSession()
	return null
}

// HAP-5052: the boot-time user load, so the route guard can wait for it on a
// protected deep link instead of bouncing a logged-in visitor to the fallback.
let userReady = Promise.resolve()

const initUser = () => {
	const user = ref({ loading: true })
	userReady = getUser(user).catch(() => {})
	return user
}

const whenUserReady = () => userReady

export { initUser, getUser, verifySession, whenUserReady, regFields }
